import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';

import NoTopicPage from './NoTopicPage';

const styles = {
  noTopicWrapper: {
    padding: '32px 64px 0',
    color: '#000000 !important',
  },
};

export default compose(withStyles(styles, { name: 'NoTopicPage' }))(NoTopicPage);



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/components/NoTopicPage/index.js